import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { toHours } from '../../helpers/helpers.js';

// Dependencies
import moment from 'moment';
import DOMPurify from 'dompurify';

const ExamMeta = observer(class ExamMeta extends React.Component {
  componentWillMount() {
    const _this = this;
    const { ExamStore } = this.props.store;
    const { examSid, sessionSid } = this.props;

    const callback = () => {
      _this.props.store.SessionStore.modalLoaded = true;
    }

    ExamStore.getSessionMeta(examSid, sessionSid, callback);
  }

  componentWillUnmount() {
    this.props.store.ExamStore.sessionMeta = null;
  }

  renderEncodedHTML(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  render() {
    const { translation } = this.props;
    const { userTimezone } = this.props.store.SessionStore;
    const { sessionMeta } = this.props.store.ExamStore;

    if(sessionMeta && sessionMeta.status && sessionMeta.status.toLowerCase() !== 'cancelled') {
      if(sessionMeta.type === 'examity') {
        const { appointmentInfo } = sessionMeta.metadata;

        return (
          <div className="modal__content--alt">
            <ul className="data--alt">
              <li>
                <strong className="subtitle">
                  {translation.appointment_date}
                </strong>

                <p>
                  {moment.utc(appointmentInfo.examDate).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z')}
                </p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.status}
                </strong>

                <p>{appointmentInfo.status}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.exam_status}
                </strong>

                <p>{appointmentInfo.examStatus}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.exam_name}
                </strong>

                <p>{appointmentInfo.examName}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.exam_duration}
                </strong>

                <p>{toHours(appointmentInfo.examDuration)}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.exam_url}
                </strong>

                <p>{appointmentInfo.examURL}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.exam_password}
                </strong>

                <p>{appointmentInfo.password}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.exam_id}
                </strong>

                <p>{appointmentInfo.examId}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.proctor_instructions}
                </strong>

                <p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.renderEncodedHTML(appointmentInfo.examInstruction))}}></p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.course_name}
                </strong>

                <p>{appointmentInfo.courseName}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.course_id}
                </strong>

                <p>{appointmentInfo.courseId}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.transaction_id}
                </strong>

                <p>{appointmentInfo.transactionId}</p>
              </li>
            </ul>
          </div>
        )
      } else if(sessionMeta.type === 'proctoru') {
        const { metadata } = sessionMeta;

        return (
          <div className="modal__content--alt">
            <ul className="data--alt">
              <li>
                <strong className="subtitle">
                  {translation.appointment_date}
                </strong>

                <p>
                  {moment.utc(metadata.StartDate).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z')}
                </p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.end_date}
                </strong>

                <p>
                  {moment.utc(metadata.EndDate).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z')}
                </p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.status}
                </strong>

                <p>{metadata.Status}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.exam_name}
                </strong>

                <p>{metadata.Test}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.exam_id}
                </strong>
                <p>{metadata.examId}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.reservation_number}
                </strong>

                <p>{metadata.ReservationNo}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.authenticated}
                </strong>

                <p>{metadata.Authenticated.toString()}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.id_checked}
                </strong>

                <p>{metadata.CheckID.toString()}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.login_verified}
                </strong>

                <p>{metadata.LoginVerified.toString()}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.test_submitted}
                </strong>

                <p>{metadata.TestSubmitted.toString()}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.escalated}
                </strong>

                <p>{metadata.Escalated.toString()}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.incident_reported}
                </strong>

                <p>{metadata.IncidentReport.toString()}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.proctor_instructions}
                </strong>

                <p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(metadata.SchoolNotes)}}></p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.notes}
                </strong>

                <p>{metadata.ProctorNotes}</p>
              </li>
            </ul>
          </div>
        )
      } else if(sessionMeta.type === 'register-blast') {
        const { metadata } = sessionMeta;

        return (
          <div className="modal__content--alt">
            <ul className="data--alt">
              <li>
                <strong className="subtitle">
                  {translation.appointment_date}
                </strong>

                <p>
                  {moment.unix(metadata.items[0].examdate).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z')}
                </p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.status}
                </strong>

                <p>{metadata.items[0].status}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.exam_name}
                </strong>

                <p>{metadata.items[0].examname}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.exam_id}
                </strong>

                <p>{metadata.items[0].examid}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.no_show}
                </strong>

                <p>{metadata.items[0].noshow.toString()}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.deleted}
                </strong>

                <p>{metadata.items[0].deleted.toString()}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.incidents}
                </strong>

                <p>{metadata.items[0].incidents.length}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.refund}
                </strong>

                <p>{metadata.items[0].refund}</p>
              </li>
              <li>
                <strong className="subtitle">
                  {translation.notes}
                </strong>

                <p>{metadata.items[0].notes}</p>
              </li>
            </ul>
          </div>
        )
      }
    } else if(sessionMeta && sessionMeta.status && sessionMeta.status.toLowerCase() === 'cancelled') {
      return (
        <div className="modal__content--alt">
          <ul className="data--alt">
            <li>
              <strong className="subtitle">
                {translation.status}
              </strong>

              <p>{sessionMeta.status}</p>
            </li>

            {sessionMeta.type &&
              <li>
                <strong className="subtitle">
                  {translation.type}
                </strong>

                <p className="capitalize">{sessionMeta.type.replace('-', ' ')}</p>
              </li>
            }
          </ul>
        </div>
      )
    }

    return null;
  }
})

export default translate('ExamMeta')(ExamMeta);



// WEBPACK FOOTER //
// ./src/app/components/Modules/ExamMeta.js